import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import cnaeSegmentReadAction from './cnaeSegmentRead.action.json' assert { type: 'json' }

const cnaeSegmentReadDefinition = defineReadAutoAction(cnaeSegmentReadAction, 'cnaeSegment')

export default cnaeSegmentReadDefinition
